export default function getRelativePath(file: string) {
  return `${process.env.REACT_APP_ROOT_PATH}${file}`;
}
